const state = {
  projectId: '',
  dataType: '0', 
  left_active: '', //点位组 
  right_active: '', //点位 
  right_active_name: '', //点位/文件集 名称
  active_algoId: '', //算法id
  active_taskId: '', //任务id - 仅视频文件使用此参数
  active_algoName: '', //算法名称
  point_dateType: '0', // 点位-时间类型
  point_time_slot: '', // 点位-时间范围
  group_active_groupId: '-1', // 点位分组：分组id
  group_active_algoId: '', //点位分组：算法id
  group_dateType: '0', // 点位分组-时间类型
  group_time_slot: '', // 点位分组-时间范围
  resultType: '', // 结果tab
};


const mutations = {
  SET_PROJECTID(state, payload) {
    state.projectId = payload
  },
  SET_DATATYPE(state, payload) {
    state.dataType = payload
  },

  SET_LEFT_ACTIVE(state, payload) {
    state.left_active = payload
  },
  SET_RIGHT_ACTIVE(state, payload) {
    if (!payload) return  // 重复点击当前点位时，保持当前点位id不变
    state.right_active = payload
  },
  SET_RIGHT_ACTIVE_NAME(state, payload) {
    if (!payload) return  // 重复点击当前点位时，保持当前点位id不变
    state.right_active_name = payload
  },
  SET_ACTIVE_ALGOID(state, payload) {
    state.active_algoId = payload
  },
  SET_ACTIVE_TASKID(state, payload) {
    state.active_taskId = payload
  },
  SET_ACTIVE_ALGONAME(state, payload) {
    state.active_algoName = payload
  },
  SET_POINT_DATETYPE(state, payload) {
    state.point_dateType = payload
  },
  SET_POINT_TIMETYPE(state, payload) {
    state.point_time_slot = payload
  },
  SET_RESULT_TYPE(state, payload) {
    state.resultType = payload
  },

  SET_GROUP_ACTIVE_GROUPID(state, payload) {
    if (!payload) return  // 重复点击当前分组时，保持当前分组id不变
    state.group_active_groupId = payload
  },
  SET_GROUP_ACTIVE_ALGOID(state, payload) {
    state.group_active_algoId = payload
  },
  SET_GROUP_DATETYPE(state, payload) {
    state.group_dateType = payload
  },
  SET_GROUP_TIMETYPE(state, payload) {
    state.group_time_slot = payload
  },
}

// 异步操作
const actions = {
  setProjectId({ commit }, data = null) {
    commit('SET_PROJECTID', data)
  },
  setDataType({ commit }, data = null) {
    commit('SET_DATATYPE', data)
  },

  // 点位查询模块
  setLeftActive({ commit }, data = null) {
    commit('SET_LEFT_ACTIVE', data)
  },
  setRightActive({ commit }, data = null) {
    commit('SET_RIGHT_ACTIVE', data)
  },
  setActiveRightName({ commit }, data = null) {
    commit('SET_RIGHT_ACTIVE_NAME', data)
  },
  setActiveAlgoId({ commit }, data = null) {
    commit('SET_ACTIVE_ALGOID', data)
  },
  setActiveTaskId({ commit }, data = null) {
    commit('SET_ACTIVE_TASKID', data)
  },
  setActiveAlgoName({ commit }, data = null) {
    commit('SET_ACTIVE_ALGONAME', data)
  },
  setPointDateType({ commit }, data = null) {
    commit('SET_POINT_DATETYPE', data)
  },
  setPointTimeType({ commit }, data = null) {
    commit('SET_POINT_TIMETYPE', data)
  },
  setResultType({ commit }, data = null) {
    commit('SET_RESULT_TYPE', data)
  },

  // 点位分组查询模块
  setGroupActiveGroupId({ commit }, data = null) {
    commit('SET_GROUP_ACTIVE_GROUPID', data)
  },
  setGroupActiveAlgoId({ commit }, data = null) {
    commit('SET_GROUP_ACTIVE_ALGOID', data)
  },
  setGroupDateType({ commit }, data = null) {
    commit('SET_GROUP_DATETYPE', data)
  },
  setGroupTimeType({ commit }, data = null) {
    commit('SET_GROUP_TIMETYPE', data)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
